import { IAnnotation, IAnnotationPopoverData } from "@bronte/viewer-api/src/main";
import "./styles.scss";
import { ReactElement } from "react";
import { isFlashCard } from "../../../shared/utils";

interface IAnnotationsPopover {
  annotationsPopoverData: IAnnotationPopoverData;
  hideAnnotationsPopover: () => void;
  setCurrentAnnotation: (_: IAnnotation) => void;
  toggleNotesPopup: (visibility: boolean) => void;
  toggleFlashcardPopup: (visibility: boolean) => void;
}

export const AnnotationsPopover = ({
  annotationsPopoverData,
  hideAnnotationsPopover,
  setCurrentAnnotation,
  toggleNotesPopup,
  toggleFlashcardPopup,
}: IAnnotationsPopover): ReactElement => {
  const handleOpenAnnotation = (annotation: IAnnotation) => {
    if (annotation.noteText) {
      setCurrentAnnotation(annotation);
      toggleFlashcardPopup(false);
      toggleNotesPopup(true);
    }
    if (isFlashCard(annotation)) {
      setCurrentAnnotation(annotation);
      toggleNotesPopup(false);
      toggleFlashcardPopup(true);
    }

    hideAnnotationsPopover();
  };

  return (
    <div
      className="annotation-icons-popup"
    >
      <ul>
        {annotationsPopoverData.annotations?.map((annotation) => (
          <li key={annotation.annotationId}>
            <span onClick={() => handleOpenAnnotation(annotation)}>
              Open {annotationsPopoverData.annotationType} &quot;{annotation.selectedText}&quot;
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
